import def from "../messagesJson/en.json";
export const PartialMessages = {
    def,
} as const;
